import gql from 'graphql-tag';

export const FRAGMENT_RESOURCE = gql`
  fragment PerformanceCenterResource on PerformanceCenterResource {
    id
    name
    dataSource
    connected
  }
`;

export const FRAGMENT_INTEGRATION_ACCOUNT = gql`
  fragment PerformanceCenterIntegrationAccount on PerformanceCenterIntegrationAccount {
    status
    accountId
    accountName
    accountType
    url
    connectedOn
  }
`;

export const FRAGMENT_AD_ACCOUNT = gql`
  fragment UserAdAccount on UserAdAccount {
    ... on BrazeUserAdAccount {
      id
      name
    }
  }
`;

export const COMPARISON_SET_FRAGMENT = gql`
  fragment ComparisonSet on ComparisonSet {
    name
    description
    userGoal
    examples
    examplesWithMetrics {
      text
      metric
    }
  }
`;

export const BENCHMARK_CONFIG_FRAGMENT = gql`
  fragment BenchmarkConfig on BenchmarkConfig {
    userCreated
    account {
      id
      name
      channel
    }
    comparisonSets {
      ...ComparisonSet
    }
    assetType
  }
  ${COMPARISON_SET_FRAGMENT}
`;

export const INTEGRATION_REQUEST_INFO_FRAGMENT = gql`
  fragment IntegrationAuthorizationRequestInfo on IntegrationAuthorizationRequestInfo {
    type
    url
  }
`;

export const INTEGRATION_ASSET = gql`
  fragment IntegrationAsset on IntegrationAsset {
    id
    accountId
    accountName
    dataSource
    updatedAt
    status
    errors
    completionPercent
    connectedAt
    customDatasetId
    estimatedActionsDuration {
      action
      timeEstimationInSeconds
    }
    generatedResources {
      id
      type
    }
  }
`;

export const INTEGRATION_ASSET_STATUS = gql`
  fragment IntegrationAssetStatus on IntegrationAsset {
    status
    errors
    completionPercent
    estimatedActionsDuration {
      action
      timeEstimationInSeconds
    }
  }
`;

export const INTEGRATION_ASSET_RESULTS = gql`
  fragment IntegrationAssetResults on IntegrationAsset {
    ...IntegrationAsset
    campaigns {
      id
      name
    }
    campaignsCopyImpressions {
      campaignName
      copyText
      impressions
    }
    integrationAssetResults {
      nodes {
        campaignNames
        id
        keywords
        lifetimeConversions
        lifetimeImpressions
        numberOfInstances
        performance
        sortIndex
        sourceAnyword
        startDate
        text
        textType
        weightedAvgCtr
      }
    }
  }
  ${INTEGRATION_ASSET}
`;
